// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + "taxonomy-edit-tree" + "." + "bf3fb821" + ".chunk.css";
};